import { Box } from '@material-ui/core';
import { BusinessOnboardingDetails } from '@nemuru-eng/js-api-client';

import { BusinessActivitySelectItems } from '@/components/modules/KYC/KYCLoan/BusinessKYC/components/BusinessIdentification/constants/BusinessActivitySelectItems';
import { BusinessTypeSelectItems } from '@/components/modules/KYC/KYCLoan/BusinessKYC/components/BusinessIdentification/constants/BusinessTypeSelectItems';
import { NationalIdTypeSelectItems } from '@/components/modules/KYC/KYCLoan/BusinessKYC/components/BusinessIdentification/constants/NationalIdTypeSelectItems';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { AutocompleteNationalityFormField } from '@/components/shared/components/NewContextForms/AutocompleteNationalityFormField/AutocompleteNationalityFormField';
import { SelectFormField } from '@/components/shared/components/NewContextForms/SelectFormField';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';

interface BusinessIdentificationFormProps extends FormGridOptions {
  businessDetails: BusinessOnboardingDetails['businessDetails'];
}

export const BusinessIdentificationForm = ({
  businessDetails,
  fullWidth,
  fieldVariant,
}: BusinessIdentificationFormProps) => {
  if (!businessDetails) return null;

  return (
    <Box pt={2}>
      <FormGridContainer fullWidth={fullWidth} fieldVariant={fieldVariant}>
        <TextFormField name={'businessName'} label={'BUSINESS_NAME'} value={businessDetails.businessName} />
        <SelectFormField
          name={'companyActivity'}
          label={'COMPANY_ACTIVITY'}
          value={businessDetails.companyActivity}
          selectOptions={BusinessActivitySelectItems}
        />
        <SelectFormField
          name={'businessType'}
          label={'BUSINESS_TYPE'}
          value={businessDetails.businessType}
          selectOptions={BusinessTypeSelectItems}
        />
        <SelectFormField
          name={'nationalIdType'}
          label={'NATIONAL_ID_TYPE'}
          value={businessDetails.nationalIdNumber.type}
          selectOptions={NationalIdTypeSelectItems}
        />
        <TextFormField
          name={'nationalIdNumber'}
          label={'NATIONAL_ID_NUMBER'}
          value={businessDetails.nationalIdNumber.number}
        />
        <AutocompleteNationalityFormField
          name={'nationality'}
          label={'NATIONALITY'}
          value={businessDetails.nationalIdNumber.nationality}
          fieldVariant={fieldVariant}
        />
      </FormGridContainer>
    </Box>
  );
};
